import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    onlineUsers: {},
};

export const onlineUsersSlice = createSlice({
    name: 'online-users',
    initialState,
    reducers: {
        setOnlineUsers(state, action) {
            state.onlineUsers = action.payload;
        },
    },
});

export const { setOnlineUsers } = onlineUsersSlice.actions;
export default onlineUsersSlice.reducer;
